module.exports = __webpack_public_path__ + "static/media/networking.e3eac5d0.jpg";